import { baseResponse } from "../DataTypes/baseResponse";
import Browsering from "../Helpers/Browsering";

export const isMobileWidth = 600;
export const br = Browsering.browser
export const isMobile = window.innerWidth<isMobileWidth
export const isSafariMobile = br === "Safari" && isMobile
export const  BASE_RESPONSE:baseResponse = {data: [], status: false, statusCode: 0, statusMessage: "BASE_RESPONSE"}